function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clamp from 'ramda/src/clamp';
import curry from 'ramda/src/curry';
import flatten from 'ramda/src/flatten';
import pathOr from 'ramda/src/pathOr';
import pluck from 'ramda/src/pluck';
import propEq from 'ramda/src/propEq';
import filter from 'ramda/src/filter';
import __ from 'ramda/src/__';
import i18n from 'invision-core/src/components/i18n/i18n';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { ROCWarningTranslatedMessageSelector } from 'invision-core/src/components/warnings/warnings.selectors';
import { MetadataCodeLoadedSelector, MetadataOptionsForCodeIntegerValuesSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { OfferingMetadataByIdSelector, OfferingMetadataPricingPlansSelector } from 'invision-core/src/components/metadata/offerings/offerings.selectors';
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
import { DiscretionaryDiscountsByCurrencySelector } from 'invision-core/src/components/metadata/discounts/discounts.selectors';
import debounce from 'lodash/debounce';
import { BILLER_RULE_INSTANCE_TYPE, DEBOUNCE_TIME_MS } from '../../../../customercare.constants';
import { PRICE_OVERRIDE_ACCESS, DISCOUNT_OVERRIDE_ACCESS, ISSUE_DISCRETIONARY_DISCOUNT, MULTIPLE_DISCOUNT_ACCESS } from '../../../../security.attributes';
import { ALLOWABLE_ACTIONS } from '../../../shared/constants/general.status.constants';
import { ActiveLifeCycleSelector, BackDecisionPageTextSelector, CompletedDecisionsSelector, DecisionsHasErrorSelector, DecisionsLifeCycleStepsForOffersSelector, DecisionsRequireAffectedServicesResolutionSelector, DecisionsRequiringAffectedServicesResolutionSelector, DiscretionaryDiscountTableDataSelector, IsFetchingBillerRuleInstanceDiscountContextSelector, IsFirstDecisionPageSelector, IsLastDecisionPageSelector, IsUpdatingCartSelector, LifeCycleDetailsForPricingPlanSelector, LifeCycleStepsPricingPlanSelector, LifeCyclesForProductsSelector, NextDecisionPageTextSelector, PageDisplayOrderSelector, PagesIsFetchingDataSelector, PagesSelector, PagesWithDecisionsSelector, PricingPlanChargeDetailsSelector, RegularDiscountTableDataSelector, SelectedPageHasErrorSelector, SelectedPageIdSelector } from '../../../../reducers/selectors/selected.offering.order.selectors';
import { SelectedOfferType } from '../../../../reducers/selectors/customer.convergent.biller.selectors';

// TODO - Customer Order wizard componentized steps should not be importing anything from a specific wizards
import { retrieveDecisionOptionServiceIds, setDecisionsRequiringAffectedServicesResolution } from '../../../../reducers/actions/edit.offer.wizard.actions';
import { EditCustomerInfoSelector } from '../../../../reducers/selectors/new.connect.wizard.selectors';
import { DecisionPagesViewModel } from './decisions.selectors';
import { clearDiscountOverride, clearSummaryQuote, decisionOptionItemQuantityChanged, decisionOptionQuantityChanged, decisionOptionSelected, decisionOptionServiceIdsForRemovalSelected, discountOverrideChanged, nonDecisionGroupOptionQuantityChanged, retrieveBillerRuleInstanceDiscountContext, setDecisionsSelectedPageId, setSavedLifeCycleId, setSelectedBriSelectedDiscounts } from '../../../../reducers/actions/offering.order.actions';
import CustomerCareKeys from '../../../../locales/keys';
import { BRI_STATUS, DecisionTypes, DISALLOW_EDIT_REASONS, EditDecisionOptionQualificationTypes, MINIMUM_DECISIONS, OfferTypes } from './decisions.constants';
// TODO - Customer Order wizard componentized steps should not be importing anything from a specific wizards
import { BulkChargeTypes } from '../../newConnectWizard/new.connect.wizard.constants';
import PricingTypeDecisions from './pricing.type.decisions';
// TODO - Customer Order wizard componentized steps should not be importing anything from a specific wizards
import { TransitionContextSelector } from '../../../../reducers/selectors/transition.offer.wizard.selectors';
import { SummaryTabViewModel } from '../../../customer/orders/create/offer/add.offer.wizard.selectors';
import { CurrentCustomerIdSelector } from '../../../../reducers/selectors/customer.selectors';
import { DependentPricingPlansIdsSelector } from '../../../../reducers/selectors/offering.order.selectors';
import { CHARGE_TIMING } from '../../../../reducers/constants/wizard.constants';
import { getMatchingOneTimeRecurringOrFinanceBriFromBrcId } from '../../../../reducers/selected.offering.order.reducer.helper';
import { buildSegmentationContext } from '../../../../reducers/helpers/offer.ordering.wizard.helper';
var DISCOUNT_TYPE_PERCENTAGE_OFF = '1';
function DecisionsController($ngRedux, $location, $anchorScroll, $timeout, uiNotificationService) {
  var _this = this;
  var disconnectRedux;
  var editOptionPopupApi;
  var financeBriOverridePopupApi;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      activeLifeCycle: ActiveLifeCycleSelector(store),
      backPageText: BackDecisionPageTextSelector(store),
      cartSummary: SummaryTabViewModel(store),
      codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
      completedDecisions: CompletedDecisionsSelector(store),
      currentCustomerId: CurrentCustomerIdSelector(store),
      customerInfoEdit: EditCustomerInfoSelector(store),
      decisionPagesViewModel: DecisionPagesViewModel(store),
      decisionsRequireAffectedServicesResolution: DecisionsRequireAffectedServicesResolutionSelector(store),
      decisionsRequiringAffectedServicesResolution: DecisionsRequiringAffectedServicesResolutionSelector(store),
      discretionaryDiscountTableData: DiscretionaryDiscountTableDataSelector(store),
      dependentPricingPlansIds: DependentPricingPlansIdsSelector(store),
      discretionaryDiscountReasonCodeOptions: MetadataOptionsForCodeIntegerValuesSelector(CODES.DiscretionaryDiscountReason, store),
      discretionaryDiscountsByCurrency: DiscretionaryDiscountsByCurrencySelector(store),
      hasValidationError: DecisionsHasErrorSelector(store),
      isConvergentBiller: IsDbss(store),
      isFetchingBillerRuleInstanceDiscountContext: IsFetchingBillerRuleInstanceDiscountContextSelector(store),
      isFirstPage: IsFirstDecisionPageSelector(store),
      isLastPage: IsLastDecisionPageSelector(store),
      isLoading: PagesIsFetchingDataSelector(store),
      isUpdatingCart: IsUpdatingCartSelector(store),
      lifeCycleChargeDetails: PricingPlanChargeDetailsSelector(store),
      lifeCyclesForProducts: LifeCyclesForProductsSelector(store),
      lifeCycleDetailsForPricingPlan: LifeCycleDetailsForPricingPlanSelector(store),
      lifeCyclePricingPlans: LifeCycleStepsPricingPlanSelector(store),
      lifeCycleSteps: DecisionsLifeCycleStepsForOffersSelector(store),
      nextPageText: NextDecisionPageTextSelector(store),
      offeringMetadata: OfferingMetadataByIdSelector(store),
      offerType: SelectedOfferType(store),
      pageOrder: PageDisplayOrderSelector(store),
      pagesMap: PagesSelector(store),
      pagesWithDecisions: PagesWithDecisionsSelector(store),
      pricingPlanMetadata: OfferingMetadataPricingPlansSelector(store),
      regularDiscountTableData: RegularDiscountTableDataSelector(store),
      rocWarningTranslatedMessage: ROCWarningTranslatedMessageSelector(store),
      selectedPageHasErrors: SelectedPageHasErrorSelector(store),
      selectedPageId: SelectedPageIdSelector(store),
      transitionContext: TransitionContextSelector(store),
      userSecurityAttributes: UserSecurityAttributesSelector(store)
    };
  };
  this.$onInit = function () {
    var codeTables = [CODES.DiscretionaryDiscountReason];
    var controllerActions = {
      clearDiscountOverride: clearDiscountOverride,
      clearSummaryQuote: clearSummaryQuote,
      decisionOptionItemQuantityChanged: decisionOptionItemQuantityChanged,
      decisionOptionQuantityChanged: decisionOptionQuantityChanged,
      decisionOptionSelected: decisionOptionSelected,
      decisionOptionServiceIdsForRemovalSelected: decisionOptionServiceIdsForRemovalSelected,
      discountOverrideChanged: discountOverrideChanged,
      fetchCodeTypes: fetchCodeTypes,
      nonDecisionGroupOptionQuantityChanged: nonDecisionGroupOptionQuantityChanged,
      retrieveBillerRuleInstanceDiscountContext: retrieveBillerRuleInstanceDiscountContext,
      retrieveDecisionOptionServiceIds: retrieveDecisionOptionServiceIds,
      retrieveOfferingsMetadata: retrieveOfferingsMetadata,
      setDecisionsRequiringAffectedServicesResolution: setDecisionsRequiringAffectedServicesResolution,
      setDecisionsSelectedPageId: setDecisionsSelectedPageId,
      setSavedLifeCycleId: setSavedLifeCycleId,
      setSelectedBriSelectedDiscounts: setSelectedBriSelectedDiscounts
    };
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.showDiscountOverridePopup = false;
    _this.MINIMUM_DECISIONS = MINIMUM_DECISIONS;
    _this.editDecisionQualTypes = EditDecisionOptionQualificationTypes;
    _this.BRI_STATUS = BRI_STATUS;
    _this.DISALLOW_EDIT_REASONS = DISALLOW_EDIT_REASONS;
    codeTables.forEach(function (codeType) {
      if (!_this.state.codeTypeLoaded(codeType)) {
        _this.actions.fetchCodeTypes(codeType).catch(function (error) {
          uiNotificationService.transientError(error.translatedMessage);
        });
      }
    });
    if (_this.selectedOfferId) {
      _this.actions.retrieveOfferingsMetadata([_this.selectedOfferId]);
    }
    if (_this.state.selectedPageId === null && _this.state.pagesWithDecisions && _this.state.pagesWithDecisions.length) {
      _this.actions.setDecisionsSelectedPageId(_this.state.pagesWithDecisions[0].Id);
    }
    _this.decisionPages = _this.state.decisionPagesViewModel;
    _this.customerCareKeys = CustomerCareKeys;
    _this.decisionTypes = DecisionTypes;
    _this.briTypes = BILLER_RULE_INSTANCE_TYPE;
    _this.tieredTemplate = require('./pricing.table.html');
    _this.triggerToolTip = require('./trigger.tooltip.html');
    _this.discountToolTip = require('../../../shared/tooltipTemplates/discount.tooltip.html');
    _this.renewalPeriodsTooltip = require('./renewal.periods.html');
    _this.selectAffectedServicesPopupConfig = {
      onRegisterApi: function onRegisterApi(_ref) {
        var api = _ref.api;
        _this.selectAffectedServicesPopupApi = api;
      }
    };
    _this.discountOverridePopupConfig = {
      onRegisterApi: function onRegisterApi(_ref2) {
        var api = _ref2.api;
        _this.discountOverridePopupPopupApi = api;
      }
    };
    _this.lifeCycleDetailsPopupConfig = {
      onRegisterApi: function onRegisterApi(_ref3) {
        var api = _ref3.api;
        _this.lifeCycleDetailsPopupConfigApi = api;
      }
    };
    _this.editOptionPopupConfig = {
      onRegisterApi: function onRegisterApi(event) {
        editOptionPopupApi = event.api;
      }
    };
    _this.financeBriOverridePopupConfig = {
      onRegisterApi: function onRegisterApi(event) {
        financeBriOverridePopupApi = event.api;
      }
    };
    _this.configurationDiscountOverridePopup = {
      appliedDiscountSelected: null,
      onCloseModal: null,
      option: {},
      tableData: []
    };
    _this.regularDiscountTableData = [];
    _this.discretionaryDiscountTableData = [];
    _this.pricingTypeDecision = new PricingTypeDecisions(_this.state.pagesWithDecisions);
    _this.tieredContext = _this.pricingTypeDecision.createTieredData(_this.state.pricingPlanMetadata);
    _this.taperedContext = _this.pricingTypeDecision.createTaperedData(_this.state.pricingPlanMetadata);
    _this.pricingTypeDgoiDecision = new PricingTypeDecisions(_this.state.pagesWithDecisions, true);
    _this.tieredContextDgoi = _this.pricingTypeDecision.createTieredData(_this.state.pricingPlanMetadata, true);
    _this.taperedContextDgoi = _this.pricingTypeDecision.createTaperedData(_this.state.pricingPlanMetadata, true);
    _this.hasPriceOverrideAccess = hasAccess(_this.state.userSecurityAttributes, PRICE_OVERRIDE_ACCESS);
    _this.hasDiscretionaryDiscountAccess = hasAccess(_this.state.userSecurityAttributes, ISSUE_DISCRETIONARY_DISCOUNT);
    _this.hasDiscountOverrideAccess = hasAccess(_this.state.userSecurityAttributes, DISCOUNT_OVERRIDE_ACCESS);
    _this.hasMultipleDiscountAccess = hasAccess(_this.state.userSecurityAttributes, MULTIPLE_DISCOUNT_ACCESS) && _this.hasDiscountOverrideAccess;
    _this.ALLOWABLE_ACTIONS = ALLOWABLE_ACTIONS;
    _this.setDecisionOptionShowingEditButtonExists();

    // TODO: remove this when DD-45915 is complete, and implement a 'Use Bulk' checkbox on the decision
    if (_this.state.pagesWithDecisions.length) {
      var decisions = flatten(pluck('decisions', _this.state.pagesWithDecisions));
      var options = flatten(pluck('Options', decisions));
      var hasBulkItems = options.some(function (option) {
        return option.Bulk === true;
      });
      if (hasBulkItems) {
        _this.callUpdateCart();
      }
    }
    _this.originalOptionQuantities = {};
    if (_this.isModify) {
      var decisionsModify = flatten(pluck('decisions', _this.state.pagesWithDecisions));
      var optionsModify = flatten(pluck('Options', decisionsModify));
      optionsModify.forEach(function (option) {
        var numberOfAddedProducts = [];
        if (_this.state.cartSummary.productGroups) {
          _this.state.cartSummary.productGroups.some(function (productGroup) {
            if (productGroup.products) {
              productGroup.products.forEach(function (product) {
                if (product.isAdded && product.offeringOptionPriceId === option.Id) {
                  numberOfAddedProducts.push(product);
                }
              });
            }
            return !!numberOfAddedProducts.length;
          });
        }
        _this.originalOptionQuantities[option.Id] = option.Quantity - numberOfAddedProducts.length;
      });
    }
    _this.retrieveServicesIds = function (option, decision, quantity) {
      var isDeviceType = _this.state.offerType === OfferTypes.DEVICE;
      var affectedDecisions = _this.state.decisionsRequiringAffectedServicesResolution.length;
      if (isDeviceType && affectedDecisions) {
        _this.actions.retrieveDecisionOptionServiceIds(_this.state.currentCustomerId, [option.Id], _this.selectedOfferingInstanceId).then(function (response) {
          // eslint-disable-next-line no-prototype-builtins
          if (response && response.hasOwnProperty('DecisionServiceIdentifiers') && response.DecisionServiceIdentifiers.length === 1) {
            var serviceIdentifier = response.DecisionServiceIdentifiers[0].ServiceIdentifiers[0];
            _this.applyDecisionAffectedServicesResolutions([{
              decisionId: decision.Id,
              optionId: option.Id,
              serviceIdentifiers: [{
                attributeId: serviceIdentifier.ServiceAttributeId,
                Id: serviceIdentifier.Value,
                Name: serviceIdentifier.Value
              }],
              updatedQuantity: quantity
            }]);
          }
        });
      }
    };
  };

  // NOTE: Avoid this at all costs... This is necessary because the parent component (i.e. the CoS wizard) can
  // dictate whether to show the popup or proceed to the intended page
  this.$onChanges = function (changes) {
    if (undefined !== changes.showSelectAffectedServicesPopup && changes.showSelectAffectedServicesPopup.currentValue !== changes.showSelectAffectedServicesPopup.previousValue) {
      if (changes.showSelectAffectedServicesPopup.currentValue) {
        _this.openSelectAffectedServicesPopup();
      } else if (!changes.showSelectAffectedServicesPopup.isFirstChange()) {
        _this.closeSelectAffectedServicesPopup();
      }
    }
    if (changes.proceedToPage && changes.proceedToPage.currentValue !== changes.proceedToPage.previousValue && !changes.proceedToPage.isFirstChange()) {
      _this.pageSelected(changes.proceedToPage.currentValue);
    }
    if (_this.actions && changes.selectedOfferId && changes.selectedOfferId.currentValue !== changes.selectedOfferId.previousValue) {
      _this.actions.retrieveOfferingsMetadata([changes.selectedOfferId.currentValue]);
    }
  };
  this.$onDestroy = function () {
    _this.cancelResolveDecisionAffectedServicesCallback();
    disconnectRedux();
  };
  this.navigatorTitle = i18n.translate(CustomerCareKeys.OFFER_DECISIONS);
  this.tierNavigatorDescriptor = {
    navigationItem: {
      active: 'selected',
      name: 'Name'
    },
    navSets: {
      name: 'name',
      navigationItems: 'decisions'
    }
  };
  this.pageSelected = function (page, childPage) {
    if (_this.state.decisionsRequireAffectedServicesResolution) {
      _this.beginResolveDecisionAffectedServicesCallback()(page);
    } else {
      var old = $location.hash();
      if (!_this.state.selectedPageHasErrors) {
        _this.actions.setDecisionsSelectedPageId(page.Id);
        _this.decisionPages = _this.state.decisionPagesViewModel;
        _this.setDecisionOptionShowingEditButtonExists();
        $timeout(function () {
          var scrollTarget = 'topOfDecisionsPage';
          if (childPage) {
            scrollTarget = childPage.item.Id;
          }
          $location.hash(scrollTarget);
          $anchorScroll();
          $location.hash(old);
        });
      } else {
        $location.hash('quantityDecisionErrorField');
        $anchorScroll();
        $location.hash(old);
      }
    }
  };
  this.shouldShowDecisionPager = function () {
    return !(_this.state.isLastPage && _this.state.isFirstPage);
  };
  this.nextPage = function () {
    if (!_this.state.isLastPage) {
      var nextPage = _this.state.pagesMap[_this.state.pageOrder[_this.state.pageOrder.indexOf(_this.state.selectedPageId) + 1]];
      _this.pageSelected(nextPage);
    }
  };
  this.previousPage = function () {
    if (!_this.state.isFirstPage) {
      var prevPage = _this.state.pagesMap[_this.state.pageOrder[_this.state.pageOrder.indexOf(_this.state.selectedPageId) - 1]];
      _this.pageSelected(prevPage);
    }
  };
  this.callUpdateCart = function () {
    if (!_this.state.hasValidationError && !_this.state.decisionsRequireAffectedServicesResolution) {
      _this.updateCart()(_this.selectedOfferId, _this.selectedOfferingInstanceId, _this.state.completedDecisions, _this.isModify, _this.customerId, undefined, _this.contextOfferingAction, _this.state.transitionContext, _this.state.isConvergentBiller, _this.customerLanguage);
    }
  };
  this.editDecisionUpdateCart = function () {
    return function (callback) {
      _this.updateCart()(_this.selectedOfferId, _this.selectedOfferingInstanceId, _this.state.completedDecisions, _this.isModify, _this.customerId, callback, _this.contextOfferingAction, _this.state.transitionContext, _this.state.isConvergentBiller, _this.customerLanguage);
    };
  };
  this.saveLifeCycle = function (lifeCycleId, isEditable) {
    _this.actions.setSavedLifeCycleId(lifeCycleId, _this.selectedOption.Id, _this.selectedDecision.Id, isEditable);
    _this.closeLifeCycleDetailsPopup();
  };
  this.getBritChargeAmount = function (brit, option) {
    var _option$BillerRuleIns;
    return (_option$BillerRuleIns = option.BillerRuleInstanceThumbnails.find(propEq(brit.BillerRuleConfigurationId, 'BillerRuleConfigurationId'))) === null || _option$BillerRuleIns === void 0 ? void 0 : _option$BillerRuleIns.Amount;
  };
  this.debouncedUpdateCart = debounce(this.callUpdateCart, DEBOUNCE_TIME_MS);
  this.selectButtonChanged = curry(function (decisionId, optionId, optionItemId, quantity) {
    if (optionItemId) {
      _this.actions.decisionOptionItemQuantityChanged(optionItemId, quantity, decisionId, optionId);
    } else {
      _this.actions.decisionOptionQuantityChanged(quantity, decisionId, optionId, true);
      _this.actions.decisionOptionSelected(decisionId, optionId);
    }
    if (_this.isQuoteCalculated) {
      _this.actions.clearSummaryQuote();
    }
    _this.debouncedUpdateCart();
  });
  this.nonDecisionGroupOptionSelectButtonChanged = curry(function (decisionId, optionId, quantity) {
    _this.actions.nonDecisionGroupOptionQuantityChanged(quantity, decisionId, optionId);
    if (_this.isQuoteCalculated) {
      _this.actions.clearSummaryQuote();
    }
    _this.debouncedUpdateCart();
  });
  this.stepperChanged = curry(function (decision, option, optionItemId, quantity) {
    var changedDecisionIsResolved = true;
    if (_this.isQuoteCalculated) {
      _this.actions.clearSummaryQuote();
    }
    if (_this.isModify && !_this.isReconnect && option.HasServiceIdentifier && !option.Bulk) {
      var changedDecisionRequiresNumAffectedServicesResolution = _this.decisionRequiresNumAffectedServicesResolution(decision.Id, option.Id, quantity);
      changedDecisionIsResolved = 0 >= changedDecisionRequiresNumAffectedServicesResolution;
      if (changedDecisionIsResolved) {
        _this.actions.decisionOptionServiceIdsForRemovalSelected(decision.Id, option.Id, undefined);
      }
      if (!optionItemId) {
        _this.actions.setDecisionsRequiringAffectedServicesResolution([{
          decisionId: decision.Id,
          numRequiredSelections: clamp(0, option.MaximumQuantity, changedDecisionRequiresNumAffectedServicesResolution),
          optionId: option.Id,
          resolved: changedDecisionIsResolved,
          updatedQuantity: quantity
        }]);
        _this.retrieveServicesIds(option, decision, quantity);
      }
    }
    if (optionItemId) {
      _this.actions.decisionOptionItemQuantityChanged(optionItemId, quantity, decision.Id, option.Id);
    } else {
      _this.actions.decisionOptionQuantityChanged(quantity, decision.Id, option.Id, false);
    }
    if (_this.state.hasValidationError) {
      _this.setCurrentStepIsInvalid()(true);
    } else {
      _this.setCurrentStepIsInvalid()(false);
      if (changedDecisionIsResolved && !_this.state.decisionsRequireAffectedServicesResolution) {
        _this.debouncedUpdateCart();
      }
    }
  });
  this.decisionRequiresNumAffectedServicesResolution = function (decisionId, optionId, updatedQuantity) {
    // TODO: Confirm the current page index is always "0"
    var originalDecisionParentValues = _this.decisionPages[0].decisions.find(propEq(true, 'selected')) || {};
    var originalDecisionValues = originalDecisionParentValues.decisions.find(propEq(decisionId, 'Id')) || {};
    var originalDecisionOptionValue = originalDecisionValues.Options.find(propEq(optionId, 'Id')) || {};
    return _this.originalOptionQuantities[originalDecisionOptionValue.Id] - updatedQuantity;
  };
  this.hasSecurityAttributesToEditDiscounts = function () {
    return _this.hasDiscountOverrideAccess && _this.hasMultipleDiscountAccess || _this.hasDiscountOverrideAccess || _this.hasDiscretionaryDiscountAccess;
  };
  this.showDiscountSection = function (brit, decision) {
    return _this.isQuantityDecision(decision) && (_this.state.discretionaryDiscountsByCurrency[brit.CurrencyCode] || brit.hasAvailableDiscounts) && brit.Type !== _this.briTypes.FINANCE && brit.Amount > 0 || brit.Type === _this.briTypes.FINANCE && (brit.selectedDiscountsInfo || []).length;
  };
  this.showDiscountEdit = function (briAmounts) {
    return briAmounts.Type !== _this.briTypes.FINANCE && _this.hasSecurityAttributesToEditDiscounts() && briAmounts.Amount > 0 && (briAmounts.hasAvailableDiscounts || _this.state.discretionaryDiscountsByCurrency[briAmounts.CurrencyCode]);
  };
  this.isBulkDecision = function (decision, option) {
    var isQuantityDecision = decision.DecisionType === _this.decisionTypes.QUANTITY;
    var isStandaloneDecision = decision.DecisionType === _this.decisionTypes.STANDALONE;
    var hasBulkOption = option ? option.Bulk : decision.Options.some(function (option) {
      return option.Bulk;
    });
    return (isQuantityDecision || isStandaloneDecision) && hasBulkOption;
  };
  this.getOptionQuantity = function (option) {
    if (option.Bulk && option.Quantity) {
      var _option$BillerRuleDet, _option$BillerRuleDet2;
      return (_option$BillerRuleDet = option.BillerRuleDetails) === null || _option$BillerRuleDet === void 0 ? void 0 : (_option$BillerRuleDet2 = _option$BillerRuleDet[0]) === null || _option$BillerRuleDet2 === void 0 ? void 0 : _option$BillerRuleDet2.Quantity;
    }
    return option.Quantity;
  };
  this.getBulkTooltip = function (billerRuleInstanceThumbnail) {
    return billerRuleInstanceThumbnail.BulkChargeTypeCode === BulkChargeTypes.FLAT ? i18n.translate(CustomerCareKeys.DECISIONS.FLAT_PRICING) : i18n.translate(CustomerCareKeys.DECISIONS.UNIT_PRICING);
  };
  this.discountTooltipText = function (discounts) {
    return "".concat(discounts.length, " ").concat(i18n.translate(discounts.length === 1 ? CustomerCareKeys.DISCOUNT : CustomerCareKeys.DISCOUNTS_LABEL));
  };
  this.getBulkIcon = function (billerRuleInstanceThumbnail) {
    return billerRuleInstanceThumbnail.BulkChargeTypeCode === BulkChargeTypes.FLAT ? 'filled-circle-f' : 'filled-circle-u';
  };
  this.isNonBulkQuantityDecision = function (decision) {
    var isQuantityDecision = decision.DecisionType === _this.decisionTypes.QUANTITY;
    var noBulkOptions = decision.Options.every(function (option) {
      return !option.Bulk;
    });
    return isQuantityDecision && noBulkOptions;
  };
  this.launchEditOption = function (option) {
    if (_this.showDecisionOptionEditButton(option)) {
      _this.setEditOption()(option);
      $timeout(function () {
        editOptionPopupApi.open();
      });
    }
  };
  this.launchFinanceBriOverrideModal = function (option) {
    if (_this.showFinanceBriChargeOverrideButton(option)) {
      _this.setEditOption()(option);
      $timeout(function () {
        financeBriOverridePopupApi.open();
      });
    }
  };
  this.isOptionEdited = function (option) {
    if (!option.Bulk || !_this.editOptions) {
      return false;
    }
    var editedOptionIds = pluck('Id')(_this.editOptions);
    if (!editedOptionIds.includes(option.Id)) {
      return false;
    } else {
      var editedOption = _this.editOptions.find(propEq(option.Id, 'Id'));
      var isEdited = option.BillerRuleInstanceThumbnails.reduce(function (isEdited, brit) {
        var editedBri = editedOption.defaultAmounts.find(propEq(brit.BillerRuleConfigurationId, 'BillerRuleConfigurationId'));
        var priceChanged = editedBri.Amount !== brit.Amount;
        return isEdited || priceChanged;
      }, false);
      return isEdited;
    }
  };
  this.isQuantityDecision = function (decision) {
    return decision.DecisionType === _this.decisionTypes.QUANTITY;
  };
  this.isDecisionGroup = function (decision) {
    return decision.DecisionType === _this.decisionTypes.GROUP;
  };
  this.isQuantityDecisionGroup = function (decision) {
    return decision.DecisionType === _this.decisionTypes.GROUP && (decision.MaximumQuantity > 1 || decision.MaximumQuantity > decision.MinimumQuantity);
  };
  this.isDefaultMaximumAndMinimumQuantityEqual = function (decision) {
    return decision.MaximumQuantity === decision.DefaultQuantity && decision.MaximumQuantity === decision.MinimumQuantity;
  };
  this.isOptionSelected = function (option) {
    return option.Selected || option.Quantity > 0;
  };
  this.isOptionItemSelected = function (item, option) {
    return item.Quantity > 0 && _this.isOptionSelected(option);
  };
  this.showStandardOptionPrice = function (option, billerConfigId) {
    //Added extra validation, to prevent un-existing array index from causing issues with display
    if (_this.tieredContext[option][billerConfigId] || _this.taperedContext[option][billerConfigId]) {
      return !_this.tieredContext[option][billerConfigId].tableItems.length && !_this.taperedContext[option][billerConfigId].tableItems.length;
    } else {
      return true;
    }
  };
  this.showStandardOptionDgoiPrice = function (option, billerConfigId) {
    //Added extra validation, to prevent un-existing array index from causing issues with display
    if (_this.tieredContextDgoi[option][billerConfigId] || _this.taperedContextDgoi[option][billerConfigId]) {
      return !_this.tieredContextDgoi[option][billerConfigId].tableItems.length && !_this.taperedContextDgoi[option][billerConfigId].tableItems.length;
    } else {
      return true;
    }
  };
  this.applyDecisionAffectedServicesResolutions = function () {
    var decisionAffectedServicesSelections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var resolvedDecisions = _this.state.decisionsRequiringAffectedServicesResolution.map(function (decision) {
      var decisionOptionResolution = decisionAffectedServicesSelections.find(function (resolution) {
        return resolution.decisionId === decision.decisionId && resolution.optionId === decision.optionId;
      });
      return decision.set('resolved', !!(decisionOptionResolution && decisionOptionResolution.serviceIdentifiers.length === decision.numRequiredSelections));
    });
    _this.actions.setDecisionsRequiringAffectedServicesResolution(resolvedDecisions);
    decisionAffectedServicesSelections.forEach(function (decision) {
      var formattedServiceIds = !decision.serviceIdentifiers.length ? undefined : decision.serviceIdentifiers.map(function (serviceId) {
        return {
          ServiceAttributeId: serviceId.attributeId,
          Value: serviceId.Id
        };
      });
      _this.actions.decisionOptionServiceIdsForRemovalSelected(decision.decisionId, decision.optionId, formattedServiceIds);
      _this.actions.decisionOptionQuantityChanged(decision.updatedQuantity, decision.decisionId, decision.optionId);
    });
    _this.closeSelectAffectedServicesPopup();
    _this.callUpdateCart();
    _this.applyDecisionAffectedServicesResolutionsCallback()();
  };
  this.cancelResolveDecisionAffectedServices = function () {
    _this.closeSelectAffectedServicesPopup();
    _this.cancelResolveDecisionAffectedServicesCallback()(true);
  };
  this.closeSelectAffectedServicesPopup = function () {
    _this.selectAffectedServicesPopupApi.close();
  };
  this.closeDiscountOverridePopup = function () {
    _this.showDiscountOverridePopup = false;
    _this.discountOverridePopupPopupApi.close();
  };
  this.closeLifeCycleDetailsPopup = function () {
    _this.lifeCycleDialogOpened = false;
    _this.lifeCycleDetailsPopupConfigApi.close();
  };
  this.openSelectAffectedServicesPopup = function () {
    $timeout(function () {
      _this.selectAffectedServicesPopupApi.open();
    });
  };
  this.submitDiscountOverride = function (decisionId, optionId, billerRuleConfigurationId, selectedDiscountsInfo) {
    _this.actions.discountOverrideChanged(decisionId, optionId, billerRuleConfigurationId, selectedDiscountsInfo);
    $timeout(function () {
      _this.debouncedUpdateCart();
      _this.closeDiscountOverridePopup();
    });
  };
  this.submitRemoveDiscountOverride = function (decisionId, optionId) {
    _this.actions.clearDiscountOverride(decisionId, optionId);
    $timeout(function () {
      _this.debouncedUpdateCart();
      _this.closeDiscountOverridePopup();
    });
  };
  this.getDiscountOverridePopupTabs = function () {
    var tabs = [];
    if (_this.state.regularDiscountTableData.length && (_this.hasDiscountOverrideAccess || _this.hasDiscountOverrideAccess && _this.hasMultipleDiscountAccess)) {
      tabs.push({
        name: i18n.translate(_this.customerCareKeys.CART.DISCOUNT_MODAL.REGULAR),
        active: false
      });
    }
    if (_this.state.discretionaryDiscountTableData.length && _this.hasDiscretionaryDiscountAccess) {
      tabs.push({
        name: i18n.translate(_this.customerCareKeys.CART.DISCOUNT_MODAL.DISCRETIONARY),
        active: false
      });
    }
    tabs[0].active = true;
    return tabs;
  };
  this.getFormattedDiscountsData = function (tableData, selectedBri, selectedDiscountsInfo) {
    return tableData.map(function (item) {
      var matchingSelectedDiscount = (selectedDiscountsInfo || []).find(function (discountInfo) {
        return "".concat(discountInfo.DiscountId) === item.discountId;
      });
      var discountAmount = matchingSelectedDiscount ? matchingSelectedDiscount.DiscountAmount : item.savings;
      if (matchingSelectedDiscount !== null && matchingSelectedDiscount !== void 0 && matchingSelectedDiscount.DiscountOverrideAmount) {
        return _objectSpread(_objectSpread({}, item), {}, {
          amount: item.discountAmountType === DISCOUNT_TYPE_PERCENTAGE_OFF ? matchingSelectedDiscount.DiscountOverrideAmount * 100 : matchingSelectedDiscount.DiscountOverrideAmount,
          isOverridden: true,
          defaultAmount: item.discountAmountType === DISCOUNT_TYPE_PERCENTAGE_OFF ? item.savings * 100 / selectedBri.chargeAmount : item.savings,
          savings: item.discountAmountType === DISCOUNT_TYPE_PERCENTAGE_OFF ? matchingSelectedDiscount.DiscountOverrideAmount * selectedBri.chargeAmount : matchingSelectedDiscount.DiscountOverrideAmount
        });
      }
      return _objectSpread(_objectSpread({}, item), {}, {
        amount: item.discountAmountType === DISCOUNT_TYPE_PERCENTAGE_OFF ? discountAmount * 100 / selectedBri.chargeAmount : item.amount,
        defaultAmount: item.discountAmountType === DISCOUNT_TYPE_PERCENTAGE_OFF ? item.savings * 100 / selectedBri.chargeAmount : item.savings,
        savings: discountAmount
      });
    });
  };
  this.openDiscountOverridePopup = function (_selectedOption, _decision, billerRuleInstanceThumbnail, showBanner) {
    var bri = getMatchingOneTimeRecurringOrFinanceBriFromBrcId(_selectedOption, billerRuleInstanceThumbnail.BillerRuleConfigurationId) || {};
    var overriddenCharge = _this.getBritChargeAmount(billerRuleInstanceThumbnail, _selectedOption);
    _this.selectedBri = {
      name: _this.getBritName(_selectedOption, billerRuleInstanceThumbnail),
      billerRuleConfigurationId: billerRuleInstanceThumbnail.BillerRuleConfigurationId,
      id: bri.Id,
      chargeAmount: overriddenCharge
    };
    _this.warningMessage = showBanner ? _this.state.rocWarningTranslatedMessage : undefined;
    _this.selectedDiscountsInfo = billerRuleInstanceThumbnail.selectedDiscountsInfo;
    _this.actions.setSelectedBriSelectedDiscounts(_this.selectedDiscountsInfo);
    var nonSelectedGlobalDiscounts = _selectedOption && _selectedOption.DefaultSelectedDiscounts ? filter(propEq(false, 'IsGlobal'))(_selectedOption.DefaultSelectedDiscounts) : [];
    var defaultSelectedDiscounts = nonSelectedGlobalDiscounts ? nonSelectedGlobalDiscounts.map(function (item) {
      return item.DiscountId;
    }) : null;
    _this.actions.retrieveBillerRuleInstanceDiscountContext(billerRuleInstanceThumbnail.BillerRuleConfigurationId, overriddenCharge, _this.customerId, _selectedOption.PricingPlanBillerRuleInstances.PricingPlanId, _decision.ProductId, _this.customerId ? undefined : buildSegmentationContext(_this.state.customerInfoEdit), _selectedOption.OrderScenario || null, defaultSelectedDiscounts).then(function () {
      var tabs = _this.getDiscountOverridePopupTabs();
      _this.configurationDiscountOverridePopup = {
        appliedDiscountSelected: _selectedOption.OverrideDiscount,
        currency: billerRuleInstanceThumbnail.CurrencyCode,
        decision: _decision,
        onCloseModal: _this.closeDiscountOverridePopup,
        onRemoveDiscount: _this.submitRemoveDiscountOverride,
        onSubmit: _this.submitDiscountOverride,
        option: _selectedOption,
        reasonCodes: _this.state.discretionaryDiscountReasonCodeOptions,
        selectedOption: _selectedOption,
        selectedTab: tabs[0],
        tabs: tabs
      };
      _this.regularDiscountTableData = _this.getFormattedDiscountsData(_this.state.regularDiscountTableData, _this.selectedBri, _this.selectedDiscountsInfo);
      _this.discretionaryDiscountTableData = _this.getFormattedDiscountsData(_this.state.discretionaryDiscountTableData, _this.selectedBri, _this.selectedDiscountsInfo);
      _this.showDiscountOverridePopup = true;
      $timeout(function () {
        _this.discountOverridePopupPopupApi.open();
      });
    }).catch(function (error) {
      uiNotificationService.transientError(error.translatedMessage);
    });
  };
  this.openLifeCycleDetailsPopup = function (decision, isDisabled, option) {
    _this.selectedOption = option;
    _this.selectedDecision = decision;
    var editOfferLifeCyclesInProductEditable = _this.lifeCyclesInProductEditable(option);
    _this.currentActiveLifeCycleStep = option.Quantity > 0 ? option.PricingPlanBillerRuleInstances.PricingPlanId : '';
    var isEditable = true;
    if (option.OfferingDecisionOptionInstances && option.OfferingDecisionOptionInstances[0].SelectedLifeCycle) {
      _this.defaultLifeCycleId = option.OfferingDecisionOptionInstances[0].SelectedLifeCycle.LifeCycleId;
      isEditable = option.OfferingDecisionOptionInstances[0].SelectedLifeCycle.IsEditable ? option.OfferingDecisionOptionInstances[0].SelectedLifeCycle.IsEditable : _this.editOfferLifeCycle ? '' : true;
    }
    var lifeCyclesForProduct = _this.state.lifeCyclesForProducts.find(function (lifeCycle) {
      return lifeCycle.productId === decision.ProductId;
    });
    var lifeCycleInPricingPlanThumbnail = Object.assign([], _this.state.lifeCycleChargeDetails);
    var filteredPricingPlans = lifeCycleInPricingPlanThumbnail.filter(function (pricingPlan) {
      return Object.values(pricingPlan)[0].pricingPlanInfo.ProductId === decision.ProductId;
    });
    _this.lifeCycleDetailsPricingPlanThumbnail = Object.assign.apply(Object, [{}].concat(_toConsumableArray(filteredPricingPlans)));
    var lifeCyclePricingPlansInProduct = Object.assign([], _this.state.lifeCyclePricingPlans);
    _this.lifeCycleChargeDetails = Object.entries(_this.lifeCycleDetailsPricingPlanThumbnail).length ? lifeCyclePricingPlansInProduct.filter(function (lifeCycle) {
      return Object.values(_this.lifeCycleDetailsPricingPlanThumbnail).find(function (pricingPlan) {
        return pricingPlan.pricingPlanInfo.Id === lifeCycle.Id;
      });
    }) : [];
    var lifeCycleDetailsForProducts = [];
    lifeCyclesForProduct.lifeCycles ? lifeCyclesForProduct.lifeCycles.forEach(function (lifeCycle) {
      var pricingPlanIds = pluck('PricingPlanId', lifeCycle.Steps);
      var pricingPlanInfo = {};
      var pricingPlanInfoForLifeCycleStep = [];
      pricingPlanIds.length ? pricingPlanIds.forEach(function (pricingPlanId) {
        pricingPlanInfo = _objectSpread(_objectSpread({}, pricingPlanInfo), _defineProperty({}, pricingPlanId, _this.lifeCycleDetailsPricingPlanThumbnail[pricingPlanId]));
      }) : [];
      lifeCycle.Steps.forEach(function (step) {
        _this.lifeCycleChargeDetails.find(function (pricingPlan) {
          if (pricingPlan.Id === step.PricingPlanId) {
            pricingPlanInfoForLifeCycleStep.push(_objectSpread(_objectSpread({}, pricingPlan), {}, {
              sortIndex: step.StepNumber
            }));
          }
        });
      });
      lifeCycleDetailsForProducts.push({
        lifeCycleDetails: lifeCycle,
        pricingPlanDetails: pricingPlanInfo,
        pricingPlanLifeCycleStep: pricingPlanInfoForLifeCycleStep.sort(function (a, b) {
          return a.sortIndex - b.sortIndex;
        }),
        isEditable: isEditable
      });
    }) : [];
    _this.lifeCycleDetailsForProductPlans = lifeCycleDetailsForProducts.filter(function (lifeCycle) {
      return lifeCycle.pricingPlanLifeCycleStep.find(function (pricingPlan) {
        return pricingPlan.Id === option.PricingPlanBillerRuleInstances.PricingPlanId;
      });
    });
    if (_this.editOfferLifeCycle) {
      _this.disableLifeCyclesEditOfferModal = pluck('isEditable', _this.lifeCycleDetailsForProductPlans).every(function (item) {
        return item === false;
      });
    }
    if (_this.disableLifeCyclesEditOfferModal) {
      _this.lifeCycleDetailsForProductPlans = lifeCycleDetailsForProducts.filter(function (lifeCycle) {
        return lifeCycle.lifeCycleDetails.Id === _this.defaultLifeCycleId;
      });
    }
    _this.lifeCycleDialogOpened = true;
    _this.disableLifeCycles = !editOfferLifeCyclesInProductEditable || isDisabled;
    $timeout(function () {
      _this.lifeCycleDetailsPopupConfigApi.open();
    });
  };
  this.isPricingPlanInLifeCycle = function (option) {
    return _this.state.lifeCyclePricingPlans.find(function (lifeCycle) {
      return lifeCycle.Id === option.PricingPlanBillerRuleInstances.PricingPlanId;
    });
  };
  this.showDecisionOptionEditButton = function (option) {
    return _this.hasPriceOverrideAccess && (option.Bulk || isBulkWithServicesOption(option) || isChargeOverridableOption(option));
  };
  this.showFinanceBriChargeOverrideButton = function (option) {
    return !option.SubscriberProductId && _this.hasPriceOverrideAccess && isFinanceBriChargeOverridableOption(option);
  };
  this.setDecisionOptionShowingEditButtonExists = function () {
    _this.decisionOptionShowingEditButtonExists = false;
    if (_this.state.pagesWithDecisions && _this.state.pagesWithDecisions.length) {
      var currentPage = _this.state.pagesWithDecisions.find(function (page) {
        return page.Id === _this.state.selectedPageId;
      });
      if (currentPage) {
        if (_this.hasPriceOverrideAccess) {
          _this.decisionOptionShowingEditButtonExists = currentPage.decisions.some(function (decision) {
            return _this.isBulkDecision(decision) || hasAnyChargeOverridableOptions(decision);
          });
        } else {
          _this.decisionOptionShowingEditButtonExists = currentPage.decisions.some(function (decision) {
            return decision.Options.some(function (option) {
              return isBulkWithServicesOption(option);
            });
          });
        }
      }
    }
  };
  var hasAnyChargeOverridableOptions = function hasAnyChargeOverridableOptions(decision) {
    return decision.Options.some(function (option) {
      return isChargeOverridableOption(option);
    });
  };
  var isChargeOverridableOption = function isChargeOverridableOption(option) {
    var filteredBris = option.PricingPlanBillerRuleInstances ? [].concat(_toConsumableArray(option.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances), _toConsumableArray(option.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances)) : [];
    return filteredBris.some(function (bri) {
      return bri.AllowChargeOverride;
    });
  };
  var isFinanceBriChargeOverridableOption = function isFinanceBriChargeOverridableOption(option) {
    return (option.PricingPlanBillerRuleInstances.FinanceBillerRuleInstances || []).some(function (bri) {
      return bri.AllowChargeOverride;
    });
  };
  var isBulkWithServicesOption = function isBulkWithServicesOption(option) {
    return option.Bulk && option.HasServiceIdentifier;
  };
  this.getName = function (option, brit) {
    return _this.state.pricingPlanMetadata[option.PricingPlanId].BillerRuleInstanceThumbnails.find(function (MetaDataBrit) {
      return MetaDataBrit.Id === brit.Id;
    }).Name;
  };
  this.getBritName = function (option, brit) {
    var briName = _this.getName(option, brit);
    if (brit.Type === _this.briTypes.SUBSCRIPTION) {
      briName = "".concat(i18n.translate(_this.customerCareKeys.BILLER_RULE_INSTANCE_TYPES.RECURRING), " ").concat(_this.state.cartSummary.productsByType[CHARGE_TIMING.DUE_TODAY][0].billCycleName);
    } else if (brit.Type === _this.briTypes.FINANCE) {
      // A finance pricing plan can have only 1 BRIT.
      if (_this.isFullUpfrontPayment(option.PricingPlanId)) {
        briName = i18n.translate(_this.customerCareKeys.DECISIONS.DUE_TODAY);
      } else if (brit.RemainingBalance) {
        briName = i18n.translate(_this.customerCareKeys.REMAINING_BALANCE);
      } else {
        briName = i18n.translate(_this.customerCareKeys.DECISIONS.FULL_PRICE);
      }
    }
    return briName;
  };
  this.isFullUpfrontPayment = function (pricingPlanId) {
    return pathOr(null, [pricingPlanId, 'PricingPlanBillerRuleInstances', 'FinanceBillerRuleInstances', 0, 'FullUpfrontPayment'], _this.state.pricingPlanMetadata);
  };
  this.lifeCyclesInProductEditable = function (option) {
    var lifeCyclesForProduct = _this.state.lifeCyclesForProducts.find(function (lifeCycle) {
      return lifeCycle.productId === option.PricingPlanBillerRuleInstances.ProductId;
    });
    if (lifeCyclesForProduct) {
      return lifeCyclesForProduct.lifeCycles.length > 1;
    }
  };
  this.isLifeCycleEditable = function (option) {
    return option.OfferingDecisionOptionInstances[0] && option.OfferingDecisionOptionInstances[0].SelectedLifeCycle ? option.OfferingDecisionOptionInstances[0].SelectedLifeCycle.IsEditable : false;
  };
  this.getDefaultLifeCycleName = function (lifeCycleObj) {
    var lifeCycleName = '';
    if (lifeCycleObj.SelectedLifeCycle) {
      _this.state.lifeCyclesForProducts.find(function (lifeCycleDetails) {
        lifeCycleDetails.lifeCycles.find(function (lifeCycle) {
          if (lifeCycle.Id === lifeCycleObj.SelectedLifeCycle.LifeCycleId) {
            lifeCycleName = lifeCycle.Name;
          }
        });
      });
    }
    return lifeCycleName;
  };
  this.enabledOption = function (option) {
    var pricingPlanId = null;
    Object.values(_this.state.offeringMetadata).forEach(function (offeringMap) {
      if (offeringMap.Options) {
        offeringMap.Options.forEach(function (optionMap) {
          if (optionMap.OptionPrices) {
            optionMap.OptionPrices.forEach(function (optionPrice) {
              if (option.Id === optionPrice.Id) {
                pricingPlanId = optionPrice.PricingPlanId;
              }
            });
          }
        });
      }
    });
    if (pricingPlanId && _this.state.dependentPricingPlansIds) {
      return _this.state.dependentPricingPlansIds.includes(pricingPlanId);
    } else {
      return false;
    }
  };
  this.getTermLength = function (option) {
    var _option$BillerRuleDet3, _option$BillerRuleDet4;
    return (option === null || option === void 0 ? void 0 : (_option$BillerRuleDet3 = option.BillerRuleDetails) === null || _option$BillerRuleDet3 === void 0 ? void 0 : (_option$BillerRuleDet4 = _option$BillerRuleDet3[0]) === null || _option$BillerRuleDet4 === void 0 ? void 0 : _option$BillerRuleDet4.TermLength) || pathOr(null, [option.PricingPlanId, 'PricingPlanBillerRuleInstances', 'FinanceBillerRuleInstances', 0, 'TermLength'], _this.state.pricingPlanMetadata);
  };
  this.getLastInvoicedBulkQuantity = function (option, brit) {
    var _option$BillerRuleIns2;
    var lastInvoicedBulkQuantity = option === null || option === void 0 ? void 0 : (_option$BillerRuleIns2 = option.BillerRuleInstanceThumbnails.find(function (briThumbnail) {
      return briThumbnail.BillerRuleConfigurationId === brit.BillerRuleConfigurationId;
    })) === null || _option$BillerRuleIns2 === void 0 ? void 0 : _option$BillerRuleIns2.LastInvoicedBulkQuantity;
    return lastInvoicedBulkQuantity;
  };
}
export default {
  template: require('./decisions.html'),
  controller: DecisionsController,
  controllerAs: 'decisionsController',
  bindings: {
    applyDecisionAffectedServicesResolutionsCallback: '&',
    beginResolveDecisionAffectedServicesCallback: '&',
    cancelResolveDecisionAffectedServicesCallback: '&',
    contextOfferingAction: '<',
    customerId: '<',
    customerLanguage: '<',
    editOption: '<',
    editOptions: '<',
    editOfferLifeCycle: '<?',
    enableDiscountOverride: '<?',
    isModify: '<',
    isReconnect: '<?',
    // To be used in conjunction with isModify flag.
    isQuoteCalculated: '<',
    isResumingOrder: '<',
    proceedToPage: '<',
    restoreOptionDefaultPricing: '&',
    saveOptionEdit: '&',
    saveBulkPricing: '&',
    selectedOfferId: '<',
    selectedOfferingInstanceId: '<?',
    setCurrentStepIsInvalid: '&',
    setEditOption: '&',
    showSelectAffectedServicesPopup: '<',
    updateCart: '&',
    updateEditOptionPrice: '&'
  }
};